<span class="icon" *ngIf="user$ | async as user" 
  [class.animated]="animated"
  [class.has-element]="element"
  [ngClass]="animated ? animated : ''" 
  [matMenuTriggerFor]="assignTo">

  <!-- Fallback -->
  <span class="initials">{{ initials }}</span>

  <!-- Gravatar -->
  <img class="gravatar" [src]="'https://www.gravatar.com/avatar/' + user.gravatarHash + '?d=blank'" 
    [matTooltip]="user.fullName" 
    matTooltipPosition="above">
</span>

<!-- Submenu: Assign to -->
<mat-menu #assignTo="matMenu">
  <ng-template matMenuContent *ngIf="element">

    <button mat-menu-item (click)="assignToUser(element, -1)"
    [class.active]="element.assignedToUserId === -1" [style.paddingLeft]="'70px'">
      {{ 'notassigned' | translate }}
    </button>

    <button mat-menu-item *ngFor="let user of users"
    (click)="assignToUser(element, user._id)"
    [class.active]="element.assignedToUserId === user._id">
      <sg2-user-icon [user]="user"></sg2-user-icon>
      {{ user.fullName }}
    </button>

  </ng-template>
</mat-menu>
